import { Injectable, inject } from '@angular/core';
import { ChecklistListState } from '../../states/checklist-list.state';
import { GetChecklistsStateResult } from './get-checklists-state.result';

@Injectable({ providedIn: 'root' })
export class GetChecklistsStateUseCase {
  private readonly _state = inject(ChecklistListState);

  public execute(): GetChecklistsStateResult {
    return {
      checklists: this._state.checklists,
      checklistsCount: this._state.checklistsCount,
      loading: this._state.loading,
      saving: this._state.saving,
      error: this._state.error,
      hasChecklists: this._state.hasChecklists,
    };
  }
}
